"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var listen_1 = require("popmotion/input/listen");

exports.default = function (element, set, activeActions, _a) {
  var onDragStart = _a.onDragStart,
      onDragEnd = _a.onDragEnd;
  return activeActions.set('dragStartListener', listen_1.default(element, 'mousedown touchstart').start(function (startEvent) {
    startEvent.preventDefault();
    set('dragging');
    if (onDragStart) onDragStart(startEvent);
    activeActions.set('dragEndListener', listen_1.default(document, 'mouseup touchend').start(function (endEvent) {
      activeActions.get('dragEndListener').stop();
      set('dragEnd');
      if (onDragEnd) onDragEnd(endEvent);
    }));
  }));
};